import { Link } from "@inertiajs/react";
import { ChevronDown } from "lucide-react";
import Logo from "../assets/fulllogo_transparent.png";
import { Button } from "./ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { Separator } from "./ui/separator";

type Props = {
  user: {
    email: string;
  };
};

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

export default function TopNav({ user }: Props) {
  return (
    <>
      <div className="mx-auto container">
        <div className="relative flex h-16 items-center justify-between">
          <div className={classNames("flex flex-1 items-center sm:items-stretch sm:justify-start")}>
            <div className="flex flex-shrink-0 items-center">
              <Link
                href="/"
                className="bg-bacgkround hover:bg-muted -mx-2 px-2 py-1 rounded-md fill-foreground"
              >
                <div className="overflow-hidden">
                  <span className="flex space-x-2 items-center">
                    <img src={Logo} className="h-10" />
                  </span>
                </div>
              </Link>
            </div>
          </div>
          <div className="absolute space-x-2 inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost">
                  Hi, {user.email} <ChevronDown className="ml-auto size-4" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                <div className="flex items-center justify-start gap-2 p-2">
                  <div className="flex flex-col space-y-1 leading-none">
                    {user.email && (
                      <p className="w-[200px] truncate text-sm text-muted-foreground">
                        {user.email}
                      </p>
                    )}
                  </div>
                </div>

                <DropdownMenuItem asChild className="cursor-pointer">
                  <Link href="/billing">Manage Subscription</Link>
                </DropdownMenuItem>

                <DropdownMenuSeparator />

                <DropdownMenuItem asChild className="cursor-pointer">
                  <Link href="/session" method="delete" as="button" className="w-full">
                    Sign out
                  </Link>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>

            {/* <ModeToggle /> */}
          </div>
        </div>
      </div>

      <Separator />
    </>
  );
}
